/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import CampaignModel from 'cio/models/campaign';
import { TrackedResponseMetricRow } from 'cio/components/campaign-metrics-page/tracked-responses-card';

interface CampaignMetricsPageTrackedResponsesCardRowArgs {
  campaign: CampaignModel;
  index: number;
  language: boolean;
  row: TrackedResponseMetricRow;
}

export default class CampaignMetricsPageTrackedResponsesCardRow extends Component<CampaignMetricsPageTrackedResponsesCardRowArgs> {
  @tracked isExpanded = true;

  get addTopBorder() {
    return this.args.index !== 0 || this.args.language;
  }

  @action toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}
